<template>
  <div>
    <div class="md-table-cell-container">
      <md-button
        class="md-just-icon md-info md-simple table-action"
        @click.native="triggerConfirmGraduation"
        v-if="item.study_status === 'studying'"
      >
        <md-tooltip md-direction="top">{{
          $t("graduated.graduation")
        }}</md-tooltip>
        <i class="fas fa-user-graduate"></i>
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  inject: ["confirmGraduation"],
  methods: {
    triggerConfirmGraduation() {
      this.confirmGraduation(this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
